// extracted by mini-css-extract-plugin
export default {"wrapper":"Table_wrapper__MlL4d","table":"Table_table__GzzIR","row":"Table_row__jXU7J","col":"Table_col__mC7Bp"};